import { SSO_ERROR_CODES, type SsoErrorCode } from '@socialsoup/shared';

const SSO_ERROR_CODE_SET: ReadonlySet<string> = new Set(Object.values(SSO_ERROR_CODES));

/**
 * Is `value` one of the shared SSO error codes? The one guard for every place the web app
 * receives a code it did not choose: the login page's `?sso_error=` parameter and the error
 * envelope of a refused SSO exchange. Anything else is treated as unknown by the caller.
 */
export function isSsoErrorCode(value: string): value is SsoErrorCode {
  return SSO_ERROR_CODE_SET.has(value);
}
